import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { IStateTree } from "../../../../store/interfaces";
import { IUser, SolfaAudioType } from "../../../../store/user/models";

import LoadableComponent from "./loadable";

const mapStateToProps = ({ user }: IStateTree) => ({
    solfaAudio: (user as IUser).solfaAudio || SolfaAudioType.Solfa,
});

export default connect(mapStateToProps)(injectIntl(LoadableComponent));
